// bundle-tracker.js v4 — title-based case detection + safe header refresh

(function() {
  'use strict';

  var BUNDLE_SIZE = 3;
  var SINGLE_PRICE = 549;
  var BUNDLE_PRICE = 999;
  var PER_UNIT = Math.round(BUNDLE_PRICE / BUNDLE_SIZE);
  var SAVINGS_PERCENT = Math.round(((SINGLE_PRICE * BUNDLE_SIZE - BUNDLE_PRICE) / (SINGLE_PRICE * BUNDLE_SIZE)) * 100);
  var DEBUG = true; // set false in production
  var refreshTimer = null;
  var lastKnownCount = -1;

  function log() {
    if (!DEBUG) return;
    var args = ['[Bundle]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function fetchCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function getPhoneModelProperties() {
    if (window.PhoneModelSelector && typeof window.PhoneModelSelector.getProperties === 'function') {
      return window.PhoneModelSelector.getProperties();
    }
    return {};
  }

  function getCartDrawerSectionId() {
    var drawerSection = document.querySelector('cart-drawer');
    return drawerSection ? drawerSection.getAttribute('data-section-id') : null;
  }

  function addVariantToCart(variantId) {
    var item = { id: parseInt(variantId, 10), quantity: 1 };
    var properties = getPhoneModelProperties();
    if (Object.keys(properties).length > 0) item.properties = properties;

    var body = { items: [item] };
    var drawerSectionId = getCartDrawerSectionId();
    if (drawerSectionId) {
      body.sections = drawerSectionId;
      body.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function(res) {
      if (!res.ok) {
        return res.text().then(function(t) {
          console.error('[Bundle] Add failed:', res.status, t);
          return null;
        });
      }
      return res.json();
    });
  }

  function isCaseItem(item) {
// Exclude addons — flagged via _is_addon or legacy _linked_to_product_id
    if (item.properties && (item.properties._is_addon || item.properties._linked_to_product_id || item.properties['Add-on for'])) return false;

    var title = (item.product_title || item.title || '').toLowerCase();
    var type = (item.product_type || '').toLowerCase();

    // Title or product type contains 'case' or 'cover'
    var hit = title.indexOf('case') !== -1 ||
              title.indexOf('cover') !== -1 ||
              type.indexOf('case') !== -1 ||
              type.indexOf('cover') !== -1;

    log('item:', item.product_title, '| type:', type, '| isCase:', hit);
    return hit;
  }

  function countCases(cart) {
    var count = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (isCaseItem(cart.items[i])) count += cart.items[i].quantity;
    }
    log('Total cases:', count);
    return count;
  }

  function computeState(count) {
    var packsComplete = Math.floor(count / BUNDLE_SIZE);
    var inPack = count % BUNDLE_SIZE;

    var fillPercent;
    if (count === 0) fillPercent = 0;
    else if (inPack === 0) fillPercent = 100;
    else fillPercent = (inPack / BUNDLE_SIZE) * 100;

    var statusText, messageText;
    var perUnitText = '\u20B9' + PER_UNIT + ' per case';

    if (count === 0) {
      statusText = '0 / 3 ADDED';
      messageText = 'Just ' + perUnitText + ' at 3 \u2014 save ' + SAVINGS_PERCENT + '%';
    } else if (packsComplete === 0) {
      statusText = count + ' / 3 ADDED';
      messageText = 'Add ' + (BUNDLE_SIZE - inPack) + ' more for ' + perUnitText;
    } else if (inPack === 0) {
      statusText = packsComplete + (packsComplete === 1 ? ' PACK UNLOCKED \u2713' : ' PACKS UNLOCKED \u2713');
      messageText = 'Add 3 more for another pack at ' + perUnitText;
    } else {
      var packLabel = packsComplete === 1 ? 'PACK' : 'PACKS';
      statusText = packsComplete + ' ' + packLabel + ' \u2713 + ' + inPack + '/3';
      messageText = 'Add ' + (BUNDLE_SIZE - inPack) + ' more for Pack ' + (packsComplete + 1);
    }

    return { fillPercent: fillPercent, statusText: statusText, messageText: messageText };
  }

  function updateUI(count) {
    if (count === lastKnownCount) return;
    var isFirstRender = lastKnownCount === -1;
    lastKnownCount = count;

    var state = computeState(count);
    log('updateUI count=' + count, 'fill=' + state.fillPercent + '%');

    var statuses = document.querySelectorAll('[data-pack-status]');
    for (var i = 0; i < statuses.length; i++) {
      statuses[i].textContent = state.statusText;
      if (!isFirstRender) {
        statuses[i].classList.remove('pulsing');
        void statuses[i].offsetWidth;
        statuses[i].classList.add('pulsing');
      }
    }

    var counts = document.querySelectorAll('[data-pack-count]');
    var inPack = count % BUNDLE_SIZE;
    var displayCount = (count > 0 && inPack === 0) ? BUNDLE_SIZE : inPack;
    for (var c = 0; c < counts.length; c++) counts[c].textContent = displayCount;

    // Force width with !important to defeat any conflicting CSS
    var fills = document.querySelectorAll('[data-pack-fill]');
    for (var j = 0; j < fills.length; j++) {
      fills[j].style.setProperty('width', state.fillPercent + '%', 'important');
    }

    var msgs = document.querySelectorAll('[data-pack-message]');
    for (var k = 0; k < msgs.length; k++) msgs[k].textContent = state.messageText;
  }

  function refresh() {
    return fetchCart().then(function(cart) {
      updateUI(countCases(cart));
    }).catch(function(e) {
      console.warn('[Bundle] Refresh error:', e);
    });
  }

  function debouncedRefresh(delay) {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function() {
      refresh();
      refreshHeaderCartIcon();
    }, delay || 200);
  }

  function notifyCartDrawer(response) {
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;
    if (typeof drawerEl.onPrepareBundledSections === 'function' && response && response.sections) {
      try {
        drawerEl.onPrepareBundledSections(response.sections);
      } catch (e) {
        console.warn('[Bundle] onPrepareBundledSections failed:', e);
      }
    }
  }

  function openCartDrawer() {
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && typeof drawerEl.show === 'function') drawerEl.show();
  }

  function refreshHeaderCartIcon() {
    // Safe approach: ONLY replace count elements, NEVER the section parent
    return fetch('/?section_id=header').then(function(r) {
      return r.text();
    }).then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');

      var selectors = [
        '[id^="cart-icon-bubble"]',
        '#cart-icon-bubble',
        'cart-count',
        '[data-cart-count-bubble]',
        '[data-cart-count]',
        '.cart-count',
        '.cart-icon-bubble',
        '.count-bubble',
        '.header__cart-count'
      ];

      var matched = false;
      for (var i = 0; i < selectors.length; i++) {
        var newEls = doc.querySelectorAll(selectors[i]);
        var currentEls = document.querySelectorAll(selectors[i]);
        if (newEls.length && currentEls.length && newEls.length === currentEls.length) {
          for (var j = 0; j < currentEls.length; j++) {
            currentEls[j].innerHTML = newEls[j].innerHTML;
          }
          log('Cart icon refreshed via selector:', selectors[i]);
          matched = true;
          break;
        }
      }
      if (!matched) {
        console.warn('[Bundle] Cart icon refresh — no selector matched. Inspect the icon and tell us its class/id.');
      }
    }).catch(function(e) {
      console.warn('[Bundle] Header refresh failed:', e);
    });
  }

  function handleClick(event) {
    var button = event.target.closest('[data-add-to-pack], [data-add-single]');
    if (!button) return;
    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      console.error('[Bundle] Missing data-variant-id on button');
      return;
    }

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING...';

    addVariantToCart(variantId).then(function(result) {
      button.disabled = false;
      button.textContent = originalText;

      if (result) {
        notifyCartDrawer(result);
        openCartDrawer();
        refresh();
        refreshHeaderCartIcon();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: result }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: result }));
      }
    });
  }

  function setupCartDrawerObserver() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      setTimeout(setupCartDrawerObserver, 1000);
      return;
    }
    var observer = new MutationObserver(function() {
      debouncedRefresh(300);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    document.addEventListener('click', handleClick);

    var cartEvents = [
      'cart:updated', 'cart:refresh', 'cart:change',
      'cart:item-added', 'cart:item-removed', 'cart:item-quantity-updated'
    ];
    cartEvents.forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        debouncedRefresh(200);
      });
    });

    setupCartDrawerObserver();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
